/**
 * Preview environment settings
 *
 * This file is where you define overrides for any of the config settings that
 * should only be applied in Vercel preview deployments.
 *
 * The preview environment is defined as 'process.env.LORE_ENV=preview', which
 * is selected by setting VERCEL_LORE_ENV=preview in the Vercel project's
 * Preview environment scope.
 *
 * Previews connect to an ephemeral backend on Fly.io (backed by a Neon
 * postgres branch) whose hostname is derived from the first 8 characters of
 * the commit SHA. The URL is computed at build time in webpack.config.js and
 * injected as PREVIEW_API_ROOT.
 */

export default {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */
  auth0: {
    clientID: 'none', // Auth0 not in the loop for preview deployments
    redirectUri: 'http://example.com/auth/callback',
  },
  connections: {
    default: {
      // eslint-disable-next-line no-undef
      apiRoot: process.env.PREVIEW_API_ROOT
    }
  },

  /**
   * Intercom is enabled in the base config; keep the widget out of
   * preview deployments so it doesn't interfere with e2e runs.
   */

  intercom: {
    enabled: false
  }

}
